<div class="cookies-alert" *ngIf="!onCloseModal">
  <div class="cookies-alert__text-block">
    <div class="cookies-alert__short-block">
      <div class="cookies-alert__header h2" i18n="@@CookieAlertShortHeader">Cookie Notice for the Site</div>
      <div class="cookies-alert__text">
        <p i18n="@@CookieAlertShortTextLine1">To ensure optimal operation and improve user experience, the site uses cookie technologies, including the Yandex.Metrica service.</p>
        <p i18n="@@CookieAlertShortTextLine2">By continuing to use the site, you agree to the placement of cookies on your device under the terms set out in the <a routerLink="/additional/privacy-policy" target="_blank" class="link link--underline order-footer__link h5">Personal Data Processing Policy.</a></p>
      </div>
    </div>

    <div class="cookies-alert__detailed-block" [ngClass]="{'show': !hideExpansionClass}" *ngIf="!hideExpansion">
      <div class="cookies-alert__text">
        <p i18n="@@CookieAlertFullTextLine1">To ensure optimal operation and improve the user experience on the site, cookies, including those from the Yandex.Metrica service, may be downloaded to your device.</p>
        <p i18n="@@CookieAlertFullTextLine2">By continuing to use the site, you agree to the use of these technologies and the placement of cookies.</p>
        <p i18n="@@CookieAlertFullTextLine3">You can delete cookies from your device through your browser settings, as well as block the placement of cookies, however, some functions of the site may not be available due to technological limitations of the engine.</p>
        <p i18n="@@CookieAlertFullTextLine4">You can find additional information in the <a routerLink="/additional/privacy-policy" target="_blank" class="link link--underline order-footer__link h5">Personal Data Processing Policy.</a></p>
      </div>
    </div>
  </div>

  <div class="cookies-alert__buttons-block">
    <button *ngIf="hideExpansion" class="button button--th-ctrl" type="button" (click)="onShowMore()">
      <span i18n="@@MoreDetails">More details</span>
    </button>

    <button class="button button--th-main" type="button" (click)="onClose()">
      <span i18n="@@ItSClear">It's clear</span>
    </button>
  </div>
</div>
